import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { QRPrintService } from 'src/app/core/services/qr-print.service';

import html2canvas from 'html2canvas';

@Component({
  selector: 'app-dialog-cash-component',
  templateUrl: './dialog-cash.component.html',
  styleUrls: ['./dialog-cash.component.scss']
})
export class DialogCashComponent {
  codeBar = '';
  isRapipago = false;
  isRapipagoOK = false;
  imageCreated;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private printService: QRPrintService
  ) {
    this.isRapipago = data.rapipago;
    this.isRapipagoOK = !data.rapipagoInOutOK;
    this.codeBar = data.codeBar;
  }

  //TODO notificaciones a la hora de error
  async;

  descargarImagen() {
    const fileName = 'yacare-rapipago.png';
    html2canvas(document.querySelector('#code'))
      .then((canvas) => {
        return (this.imageCreated = canvas.toDataURL());
      })
      .then((url) => {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => {
        return console.log('Error: ', err);
      });
  }

  imprimir() {
    const printContent = document.getElementById('print');
    const WindowPrt = window.open('', '', 'left=50,top=50,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }
}
